import { FC } from "react";
import { useSelector } from "react-redux";

import ErrorComponent from "web/Layout/Common/ErrorComponent";
import { SkeletonHeaderMenu } from "web/Layout/Common/SkeletonComponents";

import { MenuData } from "web/types/Menu";
import type { IStoreConfig } from "web/types/StoreConfig";

import useDataCachedCategories from "web/features/useDataCached/useDataCachedCategories";

import MainMenuContainerWithCategoryProductCount from "./mainMenuContainerWithCategoryProductCount";

interface IMainMenuContainerWithCategoryData {
  menu: MenuData;
  ids: number[];
}

const MainMenuContainerWithCategoryData: FC<
  IMainMenuContainerWithCategoryData
> = ({ menu, ids }) => {
  const storeConfig = useSelector(
    (state) => state.app.storeConfig
  ) as IStoreConfig;
  const { loading, error, data } = useDataCachedCategories({
    ids,
  });

  switch (true) {
    case !!loading: {
      return <SkeletonHeaderMenu />;
    }
    case !!error: {
      return <ErrorComponent />;
    }
    default: {
      return (
        <MainMenuContainerWithCategoryProductCount
          categories={data!}
          menu={menu}
          storeConfig={storeConfig}
          ids={ids}
        />
      );
    }
  }
};

export default MainMenuContainerWithCategoryData;
